import { createTheme } from "@mui/material";
import { useSelector } from "react-redux";

export const colors = {
  primary: { main: "#2A62AA", light: "#E7EEF3" },
  secondary: { main: "#E5EDF3" },
  success: { main: "#48A055" },
  warning: { main: "#EF5C00" },
  actionActive: "#919599",
  text: { main: "#3F3F40", secondary: "#656566" },
  error: { main: "#D77C89" },
  background: { white: "#ffffff" },
  nuetral: { black: "#000000" },
  light_Error: { lightPink: "#FFE6F2" },
  lightgrey: { grey: "#EEE6FF" },
  light_blue: { blue: "#E6FAFA" },
  light_White: { whiteGrey: "#F5F5F5" },
  light_Black: { main: "#376CAF" },
  dark_grey: { main: "#9C9CA4" },
  backgroundTab: { main: "#f0f0f0" },
};

export const defaultTheme = {
  primary: { main: "#2A62AA", light: "#E7EEF3" },
  secondary: { main: "#E5EDF3" },
  success: { main: "#48A055" },
  warning: { main: "#EF5C00" },
  actionActive: "#919599",
  text: { main: "#3F3F40", secondary: "#656566" },
  error: { main: "#D77C89" },
  background: { white: "#ffffff" },
  nuetral: { black: "#000000" },
  light_Error: { lightPink: "#FFE6F2" },
  lightgrey: { grey: "#EEE6FF" },
  light_blue: { blue: "#E6FAFA" },
  light_White: { whiteGrey: "#F5F5F5" },
  light_Black: { main: "#376CAF" },
  dark_grey: { main: "#9C9CA4" },
  backgroundTab: { main: "#f0f0f0" },
};

export const useThemes = () => {
  const Theme = useSelector((state: any) => state.theme?.theme);
  const isEmptyTheme = !Theme || Object.keys(Theme).length === 0;
  return isEmptyTheme ? defaultTheme : Theme;
};

export const Theme = (theme: any) => {
  return createTheme({
    palette: {
      secondary: {
        main: theme?.secondary?.main,
      },
      success: {
        main: theme?.success?.main,
      },
      warning: {
        main: theme?.warning?.main,
      },

      action: { active: theme?.actionActive },

      info: {
        main: theme?.primary?.main,
        light: theme?.primary?.light,
      },
    },
    components: {
      //------------------MuiTypography
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: "Poppins",
            "&.BarProfile": {
              color: theme?.text?.main,
              fontSize: "14px",
              fontWeight: "300",
              marginLeft: "5px",
            },
            "&.NavTP": {
              color: theme?.text?.main,
              fontSize: "20px",
              fontWeight: "200",
            },
            "&.drawer": {
              fontSize: "12px",
              // marginTop: "1px",
            },
            "&.drawerHoverColor": {
              color: theme?.primary?.main,
            },
            "&.drawerColor": {
              color: theme?.actionActive,
            },
            "&.tourModalHead": {
              fontSize: "12px",
              fontWeight: "700",
            },
            "&.tourModal": {
              fontSize: "12px",
              fontWeight: "700",
            },

            "&.tourModalIcons": {
              fontWeight: "500",
              fontSize: "14px",
              padding: "0 5px 0 0",
            },
            "&.welcomeHead": {
              fontSize: "16px",
              fontWeight: "700",
            },
            "&.welcomeSub": {
              fontSize: "12px",
              fontWeight: "500",
            },
            "&.Activity": {
              fontSize: "14px",
              fontWeight: "600",
              margin: "8px",
            },
            "&.update": {
              color: theme?.warning?.main,
              fontSize: "12px",
              fontWeight: "700",
            },
            "&.getUpdate": {
              color: theme?.warning?.main,
              fontSize: "12px",
              fontWeight: "700",
            },
            "&.getBody,&.verifyBody": {
              color: theme?.nuetral?.black,
              fontSize: "12px",
              fontWeight: "400",
            },
            "&.progress": {
              color: theme?.nuetral?.black,
              fontSize: "12px",
              fontWeight: "400",
            },
            "&.courseName": {
              fontSize: "14px",
              fontWeight: "400",
            },
            "&.flex": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            },
            "&.viewMore": {
              fontSize: "10px",
              color: theme?.text?.main,
              fontWeight: "400",
              cursor: "pointer",
            },
            "&.ApplyNowHead , &.myCertifyHead": {
              fontSize: "14px",
              fontWeight: "400",
              width: "50%",
              color: theme?.text?.main,
            },
            "&.ApplyNow &.myCertify": {
              fontSize: "14px",
              fontWeight: "400",
              color: theme?.text?.secondary,
            },
            "&.ApplyPosition": {
              fontSize: "12px",
              fontWeight: "400",
              padding: "5px 10px",
              "&.intern": {
                backgroundColor: theme?.light_Error?.lightPink,
              },
              "&.partTime": {
                backgroundColor: theme?.lightgrey?.grey,
              },
              "&.fullTime": {
                backgroundColor: theme?.light_blue?.blue,
              },
              "&.contract": {
                backgroundColor: theme?.light_White?.whiteGrey,
              },
            },
            "&.Signinto": {
              fontSize: "14px",
              marginTop: "18px",
              color: theme?.light_Black?.main,
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },

            "&.span": {
              display: "block",
              width: "25px",
              height: "2px",
              borderRadius: "3px",

              marginBottom: "5px",
              "&.white": {
                backgroundColor: theme?.background?.white,
              },
              "&.grey": {
                backgroundColor: theme?.dark_grey?.main,
              },
            },
            "&.sidebar-module": {
              fontSize: "12px",
              fontWeight: 400,
              "&.sidebar-module-black": {
                color: "#3F3F40",
              },
              "&.sidebar-module-white": {
                color: theme?.background?.white,
              },
            },
            "&.sidebar-module1": {
              fontSize: "10px",
              fontWeight: 400,
              "&.sidebar-module1-black1": {
                color: "#3F3F40",
              },
              "&.sidebar-module1-white1": {
                color: theme?.background?.white,
              },
            },
            "&.welcome-title": {
              fontSize: "14px",
              fontWeight: "700",
            },
            "&.welcome-content": {
              fontSize: "14px",
            },
            "&.transcript": {
              fontSize: "12px",
              padding: "10px",
            },
            "&.applicationModal": {
              display: "flex",
              alignItems: "center",
              "&.normal": {
                fontSize: "12px",
              },
            },
            "&.bold": {
              fontSize: "12px",
              fontWeight: "700",
            },
            "&.bold14": {
              fontSize: "14px",
              fontWeight: "600",
              color:" #3F3F40"
            },
            "&.small": {
              fontSize: "10px",
            },
            "&.tourCheckbox": {
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              fontSize: "12px",
              fontWeight: "600",
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontFamily: "poppins",
            "&.OTP": {
              width: "35px",
              height: "35px",
              margin: "5px",
              border: "1px solid",
              borderRadius: "4px",
              "&.base": {
                borderColor: "#c9cacb",
                backgroundColor: theme?.background?.white,
              },
              "&.success": {
                borderColor: "#95c69d",
                backgroundColor: "#e3ece5",
              },
              "&.error": {
                borderColor: theme?.error?.main,
                backgroundColor: "#EFDFE1",
              },
            },
            "&.experienceTextArea": {
              "&.bold": {
                fontWeight: "700",
              },
              "&.italic": {
                fontStyle: "italic",
              },
            },
            "&.InputField": { fontSize: "12px" },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          listbox: {
            "& .MuiAutocomplete-option": {
              fontFamily: "Poppins", // Your desired font
            },
            fontFamily: "Poppins", // Set your desired font
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: "poppins",
            "&.ROOT": {
              cursor: "pointer",
              boxShadow: "none",
              textTransform: "none",
              fontSize: "12px",
              fontWeight: "400",
              // gap: "8px",
              borderRadius: "6px",
              "&.disable": {
                color: "#939597",
                backgroundColor: "#edf1f4",
                border: "2px solid  #edf1f4",
              },
              "&.primary": {
                color: "white",
                backgroundColor: theme?.primary?.main,
                 border: `2px solid ${theme?.primary?.main}`,
                "&:hover": {
                  color: theme?.primary?.main,
                  backgroundColor: "#EDF1F4",
                  border: `2px solid #EDF1F4`,
                  boxShadow: "none",
                  borderRadius: "6px",
                },

               
                "&:active": {
                  border: `2px solid ${theme?.primary?.main}`,
                  backgroundColor: theme?.background?.white,
                  boxShadow: "none",
                },
              },
              "&.secondary": {
                color: theme?.primary?.main,
                backgroundColor: theme?.primary?.light,
                border: `2px solid  ${theme?.primary?.light}`,
                "&:hover": {
                  border: `2px solid  ${theme?.primary?.main}`,
                },
                "&:active": {
                  color: theme?.background?.white,
                  backgroundColor: theme?.primary?.main,
                  border: `2px solid ${theme?.primary?.main}`,
                },
              },
            },
            "&.ROOT1": {
              cursor: "pointer",
              boxShadow: "none",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "400",
              // gap: "8px",
              borderRadius: "6px",
              "&.disable": {
                color: "#939597",
                backgroundColor: "#F2F2F2",
                border: "2px solid  #F2F2F2",
              },
              "&.primary": {
                color: "white",
                backgroundColor: theme?.text?.main,
                "&:hover": {
                  color: theme?.text?.main,
                  backgroundColor: "#F2F2F2",
                  border: `2px solid #F2F2F2`,
                  boxShadow: "none",
                },

                border: `2px solid ${theme?.background?.white}`,
                "&:active": {
                  border: `2px solid${theme?.text?.main}`,
                  backgroundColor: theme?.background?.white,
                  boxShadow: "none",
                },
              },
              "&.secondary": {
                color: theme?.text?.main,
                backgroundColor: "#E5E5E5",
                border: "2px solid  #E5E5E5",
                "&:hover": {
                  border: `2px solid  ${theme?.text?.main}`,
                },
                "&:active": {
                  color: theme?.background?.white,
                  backgroundColor: theme?.text?.main,
                  border: `2px solid  ${theme?.text?.main}`,
                },
              },
            },
            "&.tourModal": {
              textTransform: "none",
              fontWeight: "700",
            },
            "&.tourModalButtonSmall": {
              textTransform: "none",
              fontWeight: "500",
              fontSize: "12px",
              cursor: "pointer",
              color: theme?.primary?.main,
            },
            "&.addExperience": {
              backgroundColor: theme?.background?.white,
              textTransform: "none",
              color: theme?.text?.main,
              fontWeight: 400,
              fontSize: "14px",
              boxShadow: "none",
              border: `1px solid ${theme?.background?.white}`,
              "&:hover": {
                border: `1px solid ${theme?.primary?.main}`,
                backgroundColor: theme?.background?.white,
                boxShadow: "none",
              },
              "&.active": { backgroundColor: theme?.primary?.main },
              "&.disable": {
                color: "#939597",
                backgroundColor: "#EDF1F4",
                border: "2px solid  #EDF1F4",
              },
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&.ROOT": {
              cursor: "pointer",
              "&.disable": {
                color: "#939597",
                backgroundColor: "#edf1f4",
                border: "2px solid  #edf1f4",
              },
              "&.secondary": {
                color: theme?.primary?.main,
                backgroundColor: theme?.primary?.light,
                border: `2px solid  ${theme?.primary?.light}`,
                "&:hover": { border: `2px solid  ${theme?.primary?.main}` },
                "&:active": {
                  color: theme?.background?.white,
                  backgroundColor: theme?.primary?.main,
                  border: `2px solid ${theme?.primary?.main}`,
                },
              },
              "&.primary": {
                color: theme?.primary?.light,
                backgroundColor: theme?.primary?.main,
                border: `2px solid  ${theme?.primary?.main}`,
                "&:hover": {
                  color: theme?.primary?.main,
                  border: `2px solid  ${theme?.primary?.main}`,
                  backgroundColor: theme?.primary?.light,
                },
                "&:active": {
                  color: theme?.primary?.main,
                  backgroundColor: theme?.background?.white,
                  border: `2px solid  ${theme?.primary?.main}`,
                },
              },
            },
            "&.verifyNav": {
              backgroundColor: theme?.warning?.main,
              "&:hover": { backgroundColor: theme?.warning?.main },
              width: 50,
              height: 50,
              color: "white",
              fontSize: "25px",
              cursor: "pointer",
            },
            "&.getting": {
              backgroundColor: theme?.warning?.main,
              "&:hover": { backgroundColor: theme?.warning?.main },
              width: 40,
              height: 40,
              color: "white",
              fontSize: "25px",
            },
            "&.getCertified": {
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              width: 12,
              height: 12,
              color: theme?.primary?.main,
              borderColor: theme?.primary?.main,
              border: "1px solid",
              fontSize: "25px",
            },
            "&.right": {
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              width: 10,
              height: 10,
              fontSize: "10px",
            },
            "&.Certify": {
              fontSize: "12px",
            },
            "&.sidebar-downArrrow": {
              color: "#CAD8EA",
              width: 20,
              height: 20,
              margin: "-5px 0 0 0 ",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            "&.tourModalCard": {
              backgroundColor: "#EDF1F4",
              height: "100%",
              width: "100%",
            },
            "&.sidebar-classroom": {
              padding: "15px",
              borderRadius: "7px",
              margin: "3px 5px",
              "&.background-blue": {
                backgroundColor: theme?.primary?.main,
              },
              "&.background-white": {
                backgroundColor: theme?.secondary?.main,
              },
            },
            "&.sidebar-classroom1": {
              padding: "15px",
              borderRadius: "7px",
              margin: "0px 5px",
              "&.background-blue": {
                backgroundColor: theme?.primary?.main,
              },
              "&.background-white": {
                backgroundColor: theme?.secondary?.main,
              },
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            "&.tourModalPaper": {
              borderRadius: 5,
              border: "none",
              backgroundColor: theme?.background?.white,
              maxHeight: "auto",
              maxWidth: 280,
              position: "absolute",
              padding: "10px",
              "&.minus": {
                display: "none",
              },
              "&.zero": {
                right: 35,
                bottom: 50,
              },
              "&.one": {
                left: 100,
                top: 75,
              },
              "&.two": {
                left: 100,
                top: 150,
              },
              "&.three": {
                left: 100,
                top: 220,
              },
              "&.four": {
                left: 100,
                top: 288,
              },
              "&.five": {
                left: 100,
                top: 360,
              },
              "&.six": {
                left: 100,
                top: 435,
              },
            },
          },
        },
      },
      //-------------------------------MuiGrid
      MuiGrid: {
        styleOverrides: {
          root: {
            "&.flexColumn": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: 64,
              backgroundColor: theme?.secondary?.main,
              minHeight: "100vh",
            },

            "&.Drawer": {
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: 8,
              color: theme?.actionActive,
              overflow: "hidden",
              maxWidth: 80,
              minWidth: 80,
              minHeight: 72,
              cursor: "pointer",
              marginTop: 5,
              "&.focus": {
                borderLeft: `4px solid ${theme?.primary?.main}`,
                borderRadius: "1px 0 0 1px",
                marginLeft: 1,
                color: theme?.primary?.main,
              },
              "&.hover": {
                "&:hover": { backgroundColor: theme?.background?.white },
              },
              "&.tourHover": {
                backgroundColor: theme?.background?.white,
              },
              "&.disable": {
                cursor: "default",
              },
            },
          },
        },
      },
      //------------------------------MuiIcon
      MuiIcon: {
        styleOverrides: {
          root: {
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&.blue": { color: theme?.primary?.main },
          },
        },
      },
      //----------------------------MuiAvatar
      MuiAvatar: {
        styleOverrides: {
          root: {
            cursor: "pointer",
            "&.BarAvatar": {
              width: 38,
              height: 38,
            },
          },
        },
      },
      //MuiToolbar
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: theme?.secondary?.main,
            width: "99%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "0 50px",
          },
        },
      },
      //MuiAppBar
      MuiAppBar: {
        styleOverrides: {
          root: {
            zIndex: 9999,
            boxShadow: "none",
            backgroundColor: theme?.secondary?.main,
          },
        },
      },
      //MuiDivider
      MuiDivider: {
        styleOverrides: {
          root: {
            "&.tourModal": {
              width: "100%",
              border: `1px solid ${theme?.background?.white}`,
            },
            "&.Vertical": {
              borderRightWidth: 0.5,
              height: "25px",
              marginRight: "15px",
              marginLeft: "10px",
              borderColor: theme?.actionActive,
              textOrientation: "vertical",
            },
            "&.tab": {
              borderRightWidth: 0.5,
              height: "25px",
              marginLeft: "auto",
              borderColor: theme?.primary?.main,
              textOrientation: "vertical",
            },
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          root: {
            "&.Side": {
              zIndex: 10,
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            width: "100%",
          },
          select: {
            height: "50px",
            minHeight: "50px",
            backgroundColor: "white",
            borderRadius: "7px",
            border: "1px solid #939597",
            padding: "0 10px",
            alignContent: "center",
            fontSize: "16px",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: "poppins",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontFamily: "poppins",
          },
        },
      },
    },
  });
};
